"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Thu Aug 02 2018
*/

var big_decimal_1 = require("@logio/big-decimal");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var RangeValidator_1 = require("../../../core/model/data-dictionary/validators/RangeValidator");

var DomainObject_1 = require("../../../core/model/DomainObject");

var Range_1 = require("../../../core/model/math/Range");
/**
 * Price distance defines what should be the distance to price strategy defined by user (how much the company wants
 * to be cheaper, same or more expensive than target according strategy definition).
 *
 * @author RV
 * @author Jan Gregor (changed from a scalar value type to a range type)
 */


var PriceDistance =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceDistance, _DomainObject_1$Domai);

  /**
   *
   * @param range Minimum and maximum percentage. E.g. values [-5, 10] mean new price should
   * not be less than 0.95*competitorPrice and not greater than 1.1*competitorPrice
   */
  function PriceDistance(range) {
    var _this;

    _classCallCheck(this, PriceDistance);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceDistance).call(this));
    _this.range = range;
    return _this;
  }

  return PriceDistance;
}(DomainObject_1.DomainObject);

exports.PriceDistance = PriceDistance;
PriceDistance.MIN_VALUE = -90;
PriceDistance.MAX_VALUE = 10000000;
PriceDistance.DEFAULT_RANGE = new Range_1.Range(big_decimal_1.bigdecimal(-50), big_decimal_1.bigdecimal(50)); // tslint:disable-next-line:member-ordering

PriceDistance.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceDistance.name);
  return {
    range: builder.obj(Range_1.Range.name, Range_1.Range.schemaBigNumber, function (mat) {
      return new Range_1.Range(mat.minimum, mat.maximum);
    }, new RangeValidator_1.RangeValidator(PriceDistance.MIN_VALUE, PriceDistance.MAX_VALUE))
  };
}();